export const BREATHING_ROOM = 0.8;
